import {CONSTANTS, stringbeginsWith} from "../meta_data";
import {Vector2} from "../delme_globals";
import globalsObject from "../globalsObject";

export class ViewerKeyboardHandler {

    private stringBufferForKonamiCode = "";

    public constructor() {
        this.initEventHandlers();
    }

    private initEventHandlers() {
        const $this = this;
        document.addEventListener("keydown", function keydown(event){$this.keyDown(event)})
        document.addEventListener("keyup", function keyup(event){ViewerKeyboardHandler.setPanningCursor(event.ctrlKey)})

    }

    private keyDown(event) {
        if (! globalsObject.owayoJSViewer.isModelLoaded) {
            return;
        }

        ViewerKeyboardHandler.setPanningCursor(event.ctrlKey);
        this.checkForKonamiCode(event);

        const stepSize = ViewerKeyboardHandler.getInteractionStepSizeFromEvent(event);


        // ALT + P öffnet ein neues Fenster mit einem "Screenshot"
        if (event.altKey && event.keyCode === 80) {
            globalsObject.owayoJSViewer.openScreenshotWindow();
            return;
        }

        if (this.isDuplicateObjectKeyboardEvent(event)) {
            event.preventDefault();
            globalsObject.owayoJSViewer.duplicateObjectByKeyboard();
            return;
        }

        if (event.keyCode === CONSTANTS.KEYCODE.ESCAPE) {
            globalsObject.owayoJSViewer.escapeKeyReleased();
            return;
        }

        if (ViewerKeyboardHandler.isMoveSelObByKeyboardRequest(event.keyCode) ) {
            globalsObject.owayoJSViewer.moveSelectedObjectByKeyboard(event.keyCode, stepSize);
            return;
        }

        globalsObject.owayoJSViewer.rotateModelByKeyboard(event.keyCode, stepSize);
    }

    private isDuplicateObjectKeyboardEvent = (event)=>event.ctrlKey && event.keyCode === CONSTANTS.KEYCODE.D && globalsObject.owayoJSViewer.selectedObject !== null;

    private static setPanningCursor(ctrKeyDown) {
        if (ctrKeyDown) {
            document.getElementById("3DViewer").classList.add("panningPossible");

        } else {
            document.getElementById("3DViewer").classList.remove("panningPossible");
        }
    }

    private checkForKonamiCode(event) {
        if (typeof(event.keyCode) === "undefined") {
            return;
        }
        this.stringBufferForKonamiCode = this.stringBufferForKonamiCode.concat(event.keyCode.toString());
        if (!stringbeginsWith(CONSTANTS.KONAMICODE, this.stringBufferForKonamiCode)) {
            this.stringBufferForKonamiCode = event.keyCode.toString();
        }
        if (this.stringBufferForKonamiCode === CONSTANTS.KONAMICODE) {
            ViewerKeyboardHandler.activateLogoFunctionsClickHandler();
        }
    }

    public static activateLogoFunctionsClickHandler() {
        (document.getElementsByClassName("logo-repeat")[0] as HTMLElement).style.display = 'block';
        (document.getElementsByClassName('logo-wasserzeichen')[0] as HTMLElement).style.display = 'block';
    }

    private static getInteractionStepSizeFromEvent(event) {
        let stepSize = 1;
        if (event.ctrlKey) {
            stepSize += 4;   //Stepsize insgesamt 5
        }
        if (event.ctrlKey && event.shiftKey) {
            stepSize += 10; //Stepsize insgesamt 15
        }
        return stepSize;
    }

    private static isMoveSelObByKeyboardRequest(keyCode) {
        const richtungsTasten = [CONSTANTS.KEYCODE.LEFT, CONSTANTS.KEYCODE.RIGHT, CONSTANTS.KEYCODE.UP, CONSTANTS.KEYCODE.DOWN];
        return globalsObject.owayoJSViewer.selectedObjectIsMovable() && (richtungsTasten.indexOf(keyCode) > -1);
    }

    public static getKeyCodeAngleMapY(modelRotationY) {
        const out = [] as number[];
        out[CONSTANTS.KEYCODE.NUMPAD0] = modelRotationY / CONSTANTS.ONE_DEGREE;
        out[CONSTANTS.KEYCODE.NUMPAD1] = -45;
        out[CONSTANTS.KEYCODE.NUMPAD2] = 0;
        out[CONSTANTS.KEYCODE.NUMPAD3] = 45;
        out[CONSTANTS.KEYCODE.NUMPAD4] = -90;
        out[CONSTANTS.KEYCODE.NUMPAD6] = 90;
        out[CONSTANTS.KEYCODE.NUMPAD7] = -135;
        out[CONSTANTS.KEYCODE.NUMPAD8] = -180;
        out[CONSTANTS.KEYCODE.NUMPAD9] = 135;
        return out;
    }

    public static getXYOperators(keyCode):{x:string,y:string}|null {
        const out = {x:"", y:""};
        switch (keyCode) {
            case CONSTANTS.KEYCODE.LEFT:
                out.x = "-=";
                break;
            case CONSTANTS.KEYCODE.RIGHT:
                out.x = "+=";
                break;
            case CONSTANTS.KEYCODE.UP:
                out.y = "+=";
                break;
            case CONSTANTS.KEYCODE.DOWN:
                out.y = "-=";
                break;
            default:
                return null;
        }
        return out;
    }

    public static isRichtungsTaste = (keyCode)=>CONSTANTS.RICHTUNGSTASTEN.indexOf(keyCode) > -1;

    public static getNewModelRotationInDegreesFromArrowKeys(modelRotation, keyCode, stepSize):Vector2 {
        const rotation = modelRotation.apply(v=>v / CONSTANTS.ONE_DEGREE);
        switch (keyCode) {
            case CONSTANTS.KEYCODE.LEFT:
                rotation.y -= stepSize;
                break;
            case CONSTANTS.KEYCODE.UP:
                rotation.x -= stepSize;
                break;
            case CONSTANTS.KEYCODE.RIGHT:
                rotation.y += stepSize;
                break;
            case CONSTANTS.KEYCODE.DOWN:
                rotation.x += stepSize;
                break;
            default:
                break;
        }
        return rotation;
    }

}